export default function getAssetsUrl(path: string, s3Assets: string): string {
  const slashTrimRegex = /^\/+|\/+$/g;
  return [s3Assets.replace(slashTrimRegex, ''), path.replace(slashTrimRegex, '')].join('/');
}
